const usdFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 2,
});

const ethFormatter = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 6,
});

export function formatUsd(value: number | null | undefined) {
  return value == null ? "—" : usdFormatter.format(value);
}

export function formatSignedUsd(value: number | null | undefined) {
  if (value == null) return "—";
  if (value === 0) return usdFormatter.format(0);
  return `${value > 0 ? "+" : "−"}${usdFormatter.format(Math.abs(value))}`;
}

export function formatPercent(value: number | null | undefined, signed = false) {
  if (value == null) return "—";
  const prefix = signed && value !== 0 ? (value > 0 ? "+" : "−") : "";
  return `${prefix}${Math.abs(value).toFixed(2)}%`;
}

export function formatEth(value: number | null | undefined) {
  return value == null ? "—" : `${ethFormatter.format(value)} ETH`;
}

export function formatDateTime(value: string | null | undefined) {
  if (!value) return "Not available";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Not available";
  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  }).format(date);
}

export function formatRelative(value: string | null | undefined) {
  if (!value) return "not yet checked";
  const milliseconds = Date.now() - new Date(value).getTime();
  if (!Number.isFinite(milliseconds)) return "not yet checked";
  const seconds = Math.max(0, Math.round(milliseconds / 1000));
  if (seconds < 10) return "just now";
  if (seconds < 60) return `${seconds}s ago`;
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.round(minutes / 60);
  return `${hours}h ago`;
}

export function pnlTone(value: number | null | undefined) {
  if (value == null || value === 0) return "neutral" as const;
  return value > 0 ? ("positive" as const) : ("negative" as const);
}
